var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.336,
    height: 14.4,
    viewBox: "0 0 14.336 14.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173010",
    "data-name": "Group 173010",
    transform: "translate(-30.369 -105.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path725",
    d: "M-261.016-156.008a1.229,1.229,0,0,1-1.13,1.309h-3.39a1.229,1.229,0,0,1-1.13-1.309v-3.09a1.229,1.229,0,0,1,1.13-1.309h3.39a1.229,1.229,0,0,1,1.13,1.309Z",
    transform: "translate(297.535 274.146)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path725-2",
    "data-name": "path725",
    d: "M-261.016-156.008a1.229,1.229,0,0,1-1.13,1.309h-3.39a1.229,1.229,0,0,1-1.13-1.309v-3.09a1.229,1.229,0,0,1,1.13-1.309h3.39a1.229,1.229,0,0,1,1.13,1.309Z",
    transform: "translate(305.221 274.146)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path729",
    d: "M-261.016-155.455a1.161,1.161,0,0,1-1.13,1.189h-3.39a1.161,1.161,0,0,1-1.13-1.189v-3.355a1.161,1.161,0,0,1,1.13-1.189h3.39a1.161,1.161,0,0,1,1.13,1.189Z",
    transform: "translate(305.221 266.047)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path729-2",
    "data-name": "path729",
    d: "M-261.016-155.455a1.161,1.161,0,0,1-1.13,1.189h-3.39a1.161,1.161,0,0,1-1.13-1.189v-3.355a1.161,1.161,0,0,1,1.13-1.189h3.39a1.161,1.161,0,0,1,1.13,1.189Z",
    transform: "translate(297.535 266.047)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.e4903a57446d4e7a885a971fc9d3878a.svg";
export { ForwardRef as ReactComponent };